import { mq } from "@/constants/breakpoints";
import { darkColor } from "@/constants/colors";
import { css } from "@emotion/react";
import { Heading, H5Css, H3Css } from "../Typography";
import Image from "next/image";

interface FAQTitleProps {
  icon: any;
  title: string;
}

const FAQTitle = ({ icon, title }: FAQTitleProps) => {
  return (
    <div
      css={css`
        margin-top: 60px;
        display: flex;
        gap: 16px;
        align-items: center;
        ${mq["lg"]} {
          gap: 30px;
          margin-top: 120px;
        }
      `}
    >
      <Image src={icon} alt={title} />
      <Heading
        level={5}
        css={css`
          color: ${darkColor};
          ${H5Css}
          ${mq["lg"]} {
            ${H3Css}
          }
        `}
      >
        {title}
      </Heading>
    </div>
  );
};

export default FAQTitle;
